import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import DatePicker from 'react-datepicker';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { FormField } from '../../../components/FormFields';
import { Button } from '../../../components/Buttons';
import { HBox, VBox } from '../../../components/Box';
import { Content } from '../../../components/Content';
import { Input } from '../../../components/Input';
import { Calendar, Check, Left, Plus, Times } from '../../../components/Icon';
import { Modal, ModalControls } from '../../../components/Modal';
import { CompanySelection } from '../../Companies/components/CompanySelection';
import { DirectionSelection } from '../components/DirectionSelection';
import { TypeSelection } from '../components/TypeSelection';
import { StatusSelection } from '../components/StatusSelection';
import { InvoiceStatus } from '../components/InvoiceStatus';
import { Checkbox } from '../../../components/Checkbox';
import { InvoiceQuizModal } from '../components/InvoiceQuizModal';
import { InvoiceSubjectContainer } from '../components/InvoiceSubject/InvoiceSubjectContainer';
import { selectInvoice, selectAutotelexBPM, selectVatCodes} from '../selectors';
import { getCurrentRestBpm, getVatCodes } from '../actions';
import {
  addInvoiceSubject,
  createCreditInvoice,
  declineInvoice,
  deleteInvoice,
  exportInvoiceToExact,
  fetchInvoice,
  finalizeV2,
  removeInvoiceSubject,
  retryFinalizationV2,
  syncBpm,
  updateInvoice,
  updateInvoiceDate,
  updateInvoiceEmailData,
  updateInvoiceOutgoingBpm,
  updateInvoiceStatus,
  updateInvoiceSubject,
} from '../actions';
import { updateRestBpmRequest, setVehicleProperties } from '../../Vehicles/actions';
import { selectConfig, selectWork } from '../../Api/selectors';
import {
  FINALIZATION_STATUSES,
  INVOICE_DIRECTIONS,
  INVOICE_SUBJECT_TYPES,
  INVOICE_TYPES,
  REQUEST_CREATE_CREDIT_INVOICE,
  REQUEST_EXACT_AUTH_STATUS,
  REQUEST_EXACT_EXPORT_INVOICE,
  REQUEST_INVOICE,
  REQUEST_INVOICE_DECLINE,
  REQUEST_INVOICE_DELETE,
  REQUEST_SYNC_BPM,
  REQUEST_UPDATE_INVOICE,
  REQUEST_UPDATE_INVOICE_OUTGOING_BPM,
} from '../constants';
import { Loader } from '../../../components/Loader';
import { FieldError } from '../../../components/FieldError';
import _ from 'lodash';
import { addApiError } from '../../Api/actions';
import { LedgersPosting } from '../components/Ledgers/LedgersPosting';
import { DeclineInvoiceModal } from '../components/DeclineInvoiceModal';
import { BpmWarningModal } from '../components/BpmWarningModal';
import { DeleteInvoiceModal } from '../components/DeleteInvoiceModal';
import { CreditInvoiceModal } from '../components/CreditInvoiceModal';
import { Permission } from '../../../components/Permission';
import { INVOICE_DELETE } from '../../../components/Permission/constants';
import { selectVehicle } from '../../Vehicles/selectors';
import { ViesCheckPrompt } from '../components/ViesCheckPrompt';
import { setCompanyProperty, checkVies } from '../../Companies/actions';
import { BTW_COUNTRIES, REQUEST_VIES_CHECK } from '../../Companies/constants';
import { PaymentsLog } from '../components/PaymentsLog';
import { InvoiceFinalizationStatusBar } from '../components/InvoiceFinalizationStatusBar';
import { OutgoingBPMModal } from '../components/OutgoingBPMModal';
import { ProductInvoiceEmailModal } from '../../products/components/productInvoiceEmailModal';
import { DecoratorLabel } from '../../../components/Input';
import { getFinalizationStatus } from '../helpers';
import { getPropByName } from '../../../utils/props';
import { selectAddressTypes } from '../../Address/selectors';
import { fetchUser } from '../../Users/actions';
import { VehicleCreateFieldCompanyUser } from '../../Vehicles/pages/create/FieldCompanyUser';
import { VehicleCreateFieldCompany } from '../../Vehicles/pages/create/FieldCompany';
import { PageHeader } from '../../../components/PageHeader';
import LoadingDetailsPage from '../../../containers/App/Components/LoadingDetailsPage/LoadingDetailsPage';
import { AUTOHUISSALLAND_INSTALATION } from '../../../containers/App/constants';
import env from '../../../env';
import dayjs from 'dayjs';
import { AppClientId } from '../../Shared/constants';
import { LoadingWithNotification } from '../../../components/LoadingWithNotification/LoadingWithNotification';
import { VehicleCreateFieldBrandName } from '../../Vehicles/pages/create/FieldBrandName';
import { VehicleCreateFieldModelName } from '../../Vehicles/pages/create/FieldModelName';
import { IconRightDecorator } from '../../../components/Icon/IconRightDecorator';
import { getDate } from '../../Vehicles/helpers';
import { Dropdown } from '../../../components/Dropdown';
import { makeSelectLocale } from '../../../containers/LanguageProvider/selectors';
import { translateCountry } from '../../Companies/translate-countries';
import { InvoiceTransportLocation } from '../components/InvoiceTransportLocation/InvoiceTansportLocation';
import { RegplateLabel } from '../../Vehicles/components/RegplateLabel';
import { VehicleAddToOrderCard } from '../../Vehicles/components/VehicleAddToOrderCard';
import CreditInvoiceEmailModal from '../components/IncomingInvoice/CreditInvoiceEmailModal';
import { WithUser } from '../../Users/components/WithUser';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';

const Container = styled.div`
  .grid {
    display: grid;
    grid-template-columns: 30% 30% 30% 10%;
  }

  .field-wrap {
    margin-bottom: 6px;
    padding: 10px;
  }
  .textLimit {
    color: ${props => (props.limit < 0 ? 'red' : 'black')};
  }
`;

const STATE = {
  incomingCompanyEdit: false,
  selectedCompanyId: null,
  selectedCompanyLabel: null,
  selectedCompanyBtwNumber: null,
  outgoingCompanyEdit: false,
  directionEdit: false,
  selectedDirection: null,
  selectedDirectionLabel: null,
  typeEdit: false,
  selectedType: null,
  selectedTypeLabel: null,
  statusEdit: false,
  selectedStatus: null,
  selectedStatusLabel: null,
  creatorEdit: false,
  showDeclineModal: false,
  bpmWarningModal: false,
  showDeleteModal: false,
  showCreditModal: false,
  showConfirmBpmModal: false,
  bpmUpdateModal: false,
  showQuizCredit: false,
  showQuizDelete: false,
  showEmailModal: false,
  extraComment: null,
  disableEditCommentButton: true,
};

const FINALIZE_REQUIRE_FIELDS = {
  regplate: 'regplate',
  vin: 'vin',
  brandName: 'brand_name',
  modelName: 'model_name',
  btwOrMarge: 'tax_type',
  date_first_allowance: 'date_first_allowance',
  mileage: 'mileage',
};

const DROPDOWN_OPTIONS = {
  btwOrMarge: ['BTW', 'marge'],
};

const RequireMark = styled.span`
  margin-left: 4 px;
  font-size: 24px;
  color: red;
`;

/* eslint-disable react/prefer-stateless-function */
class OutgoingInvoiceDetailsComp extends BaseComponent {
  constructor(props) {
    super(props, { ..._.cloneDeep(STATE) });
  }

  componentDidMount() {
    this.props.fetchInvoice(result => {
      if (result?.id) {
        this.setState({
          vehicleValues: result?.vehicle,
          companyValues: {
            BTW_number: getPropByName(result?.outgoingCompany, 'BTW_number'),
          },
        });
      }
    });
    this.props.getCode();
  }



  getFieldValue(fieldName) {
    if (Object.keys(this.state).includes(fieldName)) {
      return this.state[fieldName];
    }
    return this.props.invoice[fieldName];
  }

  get requireFields() {
    let types = [...Object.keys(FINALIZE_REQUIRE_FIELDS)].filter(
      type => !this.vehicle?.[type]
    );

    // BTW-nummer alleen als het geen Bruto-scenario is
    if (!this.getFieldValue('isBrutoScenario') && this.isOutgoingCompanyBTWRequired) {
      types.push('BTW_number');
    }

    // Verplichte velden afdwingen bij AUTOWIENTJES of bij Bruto-scenario
    const forceForClient = env.clientId === AppClientId.AUTOWIENTJES;
    const forceForBruto  = !!this.getFieldValue('isBrutoScenario');

    if (!forceForClient && !forceForBruto) {
      types = [];
    }

    return types;
  }

  get invoice() {
    return this.props.invoice;
  }

  get outgoingCompanyHome() {
    const addressTypeId = this.props.addressTypes.filter(t => t.name === 'home')[0].id;
    const homeAddress = this.props.invoice?.outgoingCompany?.addresses?.filter(address => address?.typeId == addressTypeId);

    return homeAddress ?? [];
  }

  get vehicle() {
    return this.props.invoice?.vehicle;
  }

  get extraCommentTextLimit() {
    const limit = this.state.extraComment
      ? 255 - (this.state.extraComment?.length ?? 0)
      : 255 - (this.props.invoice.invoiceAdditionalLines[0]?.value?.length ?? 0);

    return limit;
  }

  get dto() {
    let isFinal = this.getFieldValue('isFinal');
    const referenceNumber = this.getFieldValue('referenceNumber');
    const direction = this.getFieldValue('direction');

    if (direction === INVOICE_DIRECTIONS.INCOMING && !referenceNumber) {
      isFinal = false;
    }

    return {
      date: this.getFieldValue('date'),
      desiredDeliveryDate: this.getFieldValue('desiredDeliveryDate'),
      direction,
      discount: this.getFieldValue('discount'),
      dueDate: this.getFieldValue('dueDate'),
      economicalTotalAmount: this.getFieldValue('economicalTotalAmount'),
      exclVat: this.getFieldValue('exclVat'),
      financialTotalAmount: this.getFieldValue('financialTotalAmount'),
      isFinal,
      paidDate: this.getFieldValue('paidDate'),
      payments: this.getFieldValue('payments'),
      incoming: this.getFieldValue('incoming'),
      statusId: this.getFieldValue('status'),
      type: this.getFieldValue('type'),
      userCreatorId: this.getFieldValue('userCreatorId'),
      incomingCompanyId: this.getFieldValue('incomingCompanyId'),
      outgoingCompanyId: this.getFieldValue('outgoingCompanyId'),
      transportLocationId: this.getFieldValue('transportLocation')?.id ?? null,
      referenceNumber,
      invoiceAddittionalLines: [this.getFieldValue('extraComment')],
    };
  }

  isRequired(value) {
    const showRequired = this.state.showPrompt && !value;

    return showRequired && <RequireMark>*</RequireMark>;
  }

  get isOutgoingCompanyBTWRequired() {
    const btwNumber = getPropByName(this.invoice?.outgoingCompany, 'BTW_number');

    if (
      !btwNumber &&
      this.vehicle?.btwOrMarge === 'BTW' &&
      getPropByName(this.invoice?.outgoingCompany, 'company_from_eu') &&
      getPropByName(this.invoice?.outgoingCompany, 'company_from_eu')?.toLowerCase() == 'eu' &&
      getPropByName(this.invoice?.outgoingCompany, 'company_type')?.toLowerCase() == 'company' &&
      getPropByName(this.invoice?.outgoingCompany, 'IBAN')?.toLowerCase() !== 'NL12INGB0000004848'
    ) {
      return true;
    }
    return false;
  }

  onUpdate() {
    this.props.update(this.dto);

    if (this.state.getViesCheck && this.state.isFinal && this.invoice?.subjectType !== INVOICE_SUBJECT_TYPES.BPM) {
      this.setState({ getViesCheck: false, isFinal: false });
    }
  }

  datePicker(type) {
    let format = this.state.vehicleValues?.[type]?.charAt?.(2) == '-' ? 'DD-MM-YYYY' : undefined;

    let selected =
      this.state.vehicleValues?.[type] &&
      this.state.vehicleValues?.[type] !== 'null' &&
      dayjs(this.state.vehicleValues?.[type], format);
    return (
      <HBox>
        <FormField>
          <DatePicker
            dateFormat="dd-MM-yyyy"
            selected={selected && selected != 'Invalid Date' && selected.toDate()}
            onChange={date => {
              let d = dayjs(date).format('DD-MM-YYYY');

              this.setState(prev => ({
                vehicleValues: { ...prev.vehicleValues, [type]: d },
              }));
            }}
          />
          <IconRightDecorator icon={<Calendar />} />
        </FormField>
      </HBox>
    );
  }

  dropdown(type) {
    const vals = DROPDOWN_OPTIONS[type];

    const options = vals.map(val => ({
      label: this.lbl(`vehicle.property.${type}.${val}`),
      value: val,
    }));

    const value = options.find(o => o.value == this.state.vehicleValues?.[type]);

    return (
      <Dropdown
        options={options}
        value={value}
        onChange={pair =>
          this.setState(prev => ({
            vehicleValues: { ...prev.vehicleValues, [type]: pair.value },
          }))
        }
      />
    );
  }

  get btwNumberInputValue() {
    const company = this.state.companyValues;
    let options = BTW_COUNTRIES.map(c => ({ value: c.code, label: `${c.code}-${c.country}` }));
    const isWithCode = options.find(o => company?.BTW_number?.includes(o.value));
    if (isWithCode) {
      return company?.BTW_number?.substring(2) ?? '';
    }

    return company?.BTW_number ?? '';
  }

  btwDropdown() {
    const company = this.state.companyValues;
    let btwNumber = company?.BTW_number;
    let options = BTW_COUNTRIES.map(c => ({ value: c.code, label: `${c.code}-${c.country}` }));
    let value = options.find(o => btwNumber?.includes(o.value));

    return (
      <HBox>
        <div className={'dropdown-BTW'}>
          <Dropdown
            options={options}
            value={value?.value ? value?.value + ' ' : ''}
            onChange={pair => {
              if (value?.value) {
                this.setState(prev => ({
                  companyValues: {
                    ...prev.companyValues,
                    BTW_number: `${pair.value}${btwNumber?.substring(2) ?? ''}`,
                  },
                }));
                return;
              }
              this.setState(prev => ({
                companyValues: {
                  ...prev.companyValues,
                  BTW_number: `${pair.value}${btwNumber ?? ''}`,
                },
              }));
            }}
          />
        </div>
        <Input
          value={this.btwNumberInputValue}
          onChange={evt => {
            evt.persist();
            let options = BTW_COUNTRIES.map(c => ({ value: c.code, label: `${c.code}-${c.country}` }));
            const isWithCode = options.find(o => btwNumber?.includes(o.value));

            if (isWithCode?.value) {
              this.setState(prev => ({
                companyValues: {
                  ...prev.companyValues,
                  BTW_number: `${isWithCode?.value}${evt.target.value}`,
                },
              }));
              return;
            }
            this.setState(prev => ({
              companyValues: {
                ...prev.companyValues,
                BTW_number: evt.target.value,
              },
            }));
          }}
        />
      </HBox>
    );
  }

  onVehicleValueChange(evt, propertyName = '', propertyValue = '') {
    if (propertyName === 'brandName' || propertyName === 'modelName') {
      this.setState(prev => ({
        vehicleValues: { ...prev.vehicleValues, [propertyName]: propertyValue },
      }));
      return;
    }
    evt.persist();
    this.setState(prev => ({
      vehicleValues: { ...prev.vehicleValues, [evt.target.name]: evt.target.value },
    }));
  }

  onUpdateVehicle() {
    let properties = [];

    Object.keys(FINALIZE_REQUIRE_FIELDS)?.forEach(propertyName => {
      if (this.state.vehicleValues?.[propertyName]) {
        properties.push({
          propertyName: FINALIZE_REQUIRE_FIELDS[propertyName],
          propertyValue: this.state.vehicleValues?.[propertyName],
        });
      }
    });

    this.props.updateVehicle(this.vehicle.id, properties, result => {
      if (result) {
        this.setState({ showPrompt: false, requireField: [] });
        this.props.fetchInvoice();
      }
    });
  }

  onSetCompanyProperty(propertyName, propertyValue) {
    this.props.updateCompanyProperty(this.getFieldValue('outgoingCompanyId'), propertyName, propertyValue, () => {
      this.setState({ showPrompt: false, requireField: [] });
      this.props.fetchInvoice();
    });
  }

  onEditOutgoingCompany() {
    this.setState(prev => {
      return { ...prev, outgoingCompanyEdit: true };
    });
  }

  onEditDirection() {
    this.setState(prev => {
      return { ...prev, directionEdit: true };
    });
  }

  onEditType() {
    this.setState(prev => {
      return { ...prev, typeEdit: true };
    });
  }

  onEditStatus() {
    this.setState(prev => {
      return { ...prev, statusEdit: true };
    });
  }

  onChangeCompanySelection(company) {
    this.setState(prev => {
      return {
        ...prev,
        selectedCompanyLabel: company.name ?? company.name ?? '',
        selectedCompanyId: company.id,
        selectedCompanyBtwNumber: company?.BTW_number,
      };
    });
  }

  onChangeDirectionSelection(direction) {
    this.setState(prev => {
      return { ...prev, selectedDirectionLabel: direction.label, selectedDirection: direction.id };
    });
  }

  onChangeTypeSelection(type) {
    this.setState(prev => {
      return { ...prev, selectedTypeLabel: type.label, selectedType: type.id };
    });
  }

  onChangeStatusSelection(status) {
    this.setState(prev => {
      return { ...prev, selectedStatusLabel: status.label, selectedStatus: status.id };
    });
  }

  onChangeIncomingCompany() {
    this.setState(prev => {
      return {
        ...prev,
        incomingCompanyLabel: prev.selectedCompanyLabel,
        incomingCompanyId: prev.selectedCompanyId,
        incoming_btw_number: prev.selectedCompanyBtwNumber,
        incomingCompanyEdit: false,
        selectedCompanyId: null,
        selectedCompanyLabel: null,
        selectedCompanyBtwNumber: null,
      };
    });
  }

  onChangeOutgoingCompany() {
    this.setState(prev => {
      return {
        ...prev,
        outgoingCompanyLabel: prev.selectedCompanyLabel,
        outgoingCompanyId: prev.selectedCompanyId,
        outgoing_btw_number: prev.selectedCompanyBtwNumber,
        outgoingCompanyEdit: false,
        selectedCompanyId: null,
        selectedCompanyLabel: null,
        selectedCompanyBtwNumber: null,
      };
    });
  }

  onChangeDirection() {
    this.setState(prev => {
      return {
        ...prev,
        directionLabel: prev.selectedDirectionLabel,
        direction: prev.selectedDirection,
        directionEdit: false,
        selectedDirection: null,
        selectedDirectionLabel: null,
      };
    });
  }

  onChangeType() {
    this.setState(prev => {
      return {
        ...prev,
        typeLabel: prev.selectedTypeLabel,
        type: prev.selectedType,
        typeEdit: false,
        selectedType: null,
        selectedTypeLabel: null,
      };
    });
  }

  onChangeStatus() {
    this.props.updateInvoiceStatus(this.state.selectedStatus, () => {
      this.setState(prev => {
        return {
          ...prev,
          statusLabel: prev.selectedStatusLabel,
          status: prev.selectedStatus,
          statusEdit: false,
          selectedStatus: null,
          selectedStatusLabel: null,
        };
      });
    });
  }

  onResetIncomingUser() {
    this.setState(prev => {
      return { ...prev, incomingUserLabel: null, incomingUserId: null };
    });
  }

  onResetIncomingCompany() {
    this.setState(prev => {
      return { ...prev, incomingCompanyLabel: null, incomingCompanyId: null };
    });
  }

  onResetOutgoingCompany() {
    this.setState(prev => {
      return { ...prev, outgoingCompanyLabel: null, outgoingCompanyId: null };
    });
  }

  onResetDirection() {
    this.setState({ directionLabel: null, direction: null });
  }

  onResetType() {
    this.setState(prev => {
      return { ...prev, typeLabel: null, type: null };
    });
  }

  onResetStatus() {
    this.setState(prev => {
      return { ...prev, statusLabel: null, status: null };
    });
  }

  closeIncomingCompanyEdit() {
    this.setState(prev => {
      return { ...prev, incomingCompanyEdit: false, selectedCompanyId: null, selectedCompanyLabel: null };
    });
  }

  closeOutgoingCompanyEdit() {
    this.setState(prev => {
      return { ...prev, outgoingCompanyEdit: false, selectedCompanyId: null, selectedCompanyLabel: null };
    });
  }

  closeDirectionEdit() {
    this.setState(prev => {
      return { ...prev, directionEdit: false, selectedDirection: null, selectedDirectionLabel: null };
    });
  }

  closeTypeEdit() {
    this.setState(prev => {
      return { ...prev, typeEdit: false, selectedType: null, selectedTypeLabel: null };
    });
  }

  closeStatusEdit() {
    this.setState(prev => {
      return { ...prev, statusEdit: false, selectedStatus: null, selectedStatusLabel: null };
    });
  }

  get vatCodes() {
    return this.props.vatCodes ?? [];
  }


  getVatCodeLabel(code) {
    return this.vatCodes?.filter(vatCode => vatCode.code == code);
  }

  reset() {
    this.setState(
      { ...this.props.invoice, getViesCheck: false } ?? {
        getViesCheck: false,
      },
    );
  }

  renderOutgoingCompany() {
    if (this.getFieldValue('outgoingCompanyId')) {
      return (
        <Input style={{ width: '100%' }} disabled value={this.getFieldValue('outgoingCompanyLabel') ?? ''}>
          {/* <Times onClick={this.onResetOutgoingCompany.bind(this)} /> */}
        </Input>
      );
    }

    return <Plus onClick={this.onEditOutgoingCompany.bind(this)} />;
  }

  renderDirection() {
    if (this.getFieldValue('directionLabel')) {
      return (
        <FormField>
          <Input
            style={{ width: '100%' }}
            disabled
            value={
              this.getFieldValue('directionLabel') === 'outgoing'
                ? 'Uitgaand'
                : this.getFieldValue('directionLabel') === 'incoming'
                ? 'Inkomend'
                : ''
            }
          ></Input>
        </FormField>
      );
    }

    return <Plus onClick={this.onEditDirection.bind(this)} />;
  }

  renderType() {
    if (this.getFieldValue('typeLabel')) {
      return (
        <FormField>
          <Input style={{ width: '100%' }} disabled value={this.getFieldValue('typeLabel') ?? ''}></Input>
        </FormField>
      );
    }

    return <Plus onClick={this.onEditType.bind(this)} />;
  }

  renderStatus() {
    if (this.getFieldValue('statusLabel')) {
      return (
        <HBox onClick={this.onEditStatus.bind(this)}>
          <InvoiceStatus status={this.getFieldValue('statusLabel')} />
          {/*<Times onClick={this.onResetStatus.bind(this)} />*/}
        </HBox>
      );
    }

    return <Plus onClick={this.onEditStatus.bind(this)} />;
  }

  renderBpmInvoiceAdditionalVehicleInfo() {
    if (this.invoice.subjectType !== INVOICE_SUBJECT_TYPES.BPM) return;

    const modelInfo = this.vehicle?.description.includes('|')
      ? this.vehicle.description.split('|')?.[1]?.trim()
      : this.vehicle.description;
    return (
      <>
        <HBox vCenter className="field-wrap">
          <strong style={{ flex: '30%' }}>{this.lbl('vehicle.filter.regplate')}</strong>
          <HBox style={{ width: '70%' }}>
            <FormField style={{ width: '100%' }}>
              <Input style={{ width: '100%' }} strongValue disabled value={this.vehicle?.regplate ?? ''} />
            </FormField>
          </HBox>
        </HBox>
        <HBox vCenter className="field-wrap">
          <strong style={{ flex: '30%' }}>{this.lbl('vehicle.filter.brand_model')}</strong>
          <HBox style={{ width: '70%' }}>
            <FormField style={{ width: '100%', fontWeight: '600' }}>
              <Input style={{ width: '100%' }} strongValue disabled value={modelInfo} />
            </FormField>
          </HBox>
        </HBox>
      </>
    );
  }

  renderDeclined() {
    return (
      <VBox>
        <p>{this.lbl('invoice.create.isDeclined')}</p>
        <Checkbox checked={!!this.getFieldValue('creditInvoiceId')}></Checkbox>
      </VBox>
    );
  }

  renderIncomingCompanyEdit() {
    if (!this.getFieldValue('incomingCompanyEdit')) return '';

    return (
      <Modal title={this.lbl('confirm')}>
        {this.state.selectedCompanyId ? (
          <VBox>{this.state.selectedCompanyLabel}</VBox>
        ) : (
          <CompanySelection
            order
            user={{ id: this.getFieldValue('incomingCompanyId') }}
            onSelect={this.onChangeCompanySelection.bind(this)}
          />
        )}
        <ModalControls>
          <Button onClick={this.onChangeIncomingCompany.bind(this)}>{this.lbl('add')}</Button>
          <Button onClick={this.closeIncomingCompanyEdit.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  renderOutgoingCompanyEdit() {
    if (!this.getFieldValue('outgoingCompanyEdit')) return '';

    return (
      <Modal title={this.lbl('confirm')}>
        {this.getFieldValue('selectedCompanyId') ? (
          <VBox>{this.getFieldValue('selectedCompanyLabel')}</VBox>
        ) : (
          <CompanySelection
            invoiceCompany
            user={{ id: this.getFieldValue('incomingCompanyId') }}
            onSelect={this.onChangeCompanySelection.bind(this)}
          />
        )}
        <ModalControls>
          <Button onClick={this.onChangeOutgoingCompany.bind(this)}>{this.lbl('add')}</Button>
          <Button onClick={this.closeOutgoingCompanyEdit.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  renderDirectionEdit() {
    if (!this.getFieldValue('directionEdit')) return '';

    return (
      <Modal title={this.lbl('confirm')}>
        {this.state.selectedDirection ? (
          <VBox>{this.state.selectedDirectionLabel}</VBox>
        ) : (
          <DirectionSelection onSelect={this.onChangeDirectionSelection.bind(this)} />
        )}
        <ModalControls>
          <Button onClick={this.onChangeDirection.bind(this)}>{this.lbl('add')}</Button>
          <Button onClick={this.closeDirectionEdit.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  renderTypeEdit() {
    if (!this.getFieldValue('typeEdit')) return '';

    return (
      <Modal title={this.lbl('confirm')}>
        {this.state.selectedType ? (
          <VBox>{this.state.selectedTypeLabel}</VBox>
        ) : (
          <TypeSelection onSelect={this.onChangeTypeSelection.bind(this)} />
        )}
        <ModalControls>
          <Button onClick={this.onChangeType.bind(this)}>{this.lbl('add')}</Button>
          <Button onClick={this.closeTypeEdit.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  renderStatusEdit() {
    if (!this.state.statusEdit) return '';
    if (!this.props.serverConfig.manualPaymentStatus) return this.renderStatusEditStub();

    return (
      <ModalComponent title={this.lbl('invoice.invoice_status')}>
        {this.state.selectedStatus ? (
          <VBox>{this.lbl('translate.' + this.state.selectedStatusLabel)}</VBox>
        ) : (
          <StatusSelection onSelect={this.onChangeStatusSelection.bind(this)} />
        )}
        <div className="d-flex gap-2">
          <ButtonComponent style={'ButtonSoftEdit'} onClick={this.onChangeStatus.bind(this)}>
            {this.lbl('update')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.closeStatusEdit.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  renderStatusEditStub() {
    return (
      <ModalComponent title={this.lbl('status')}>
        {this.lbl('invoice.statusEditStubMsg')}
        <div className="d-flex">
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.closeStatusEdit.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  onSaveSubject(subject) {
    const subjectId = subject.id;
    if (!subjectId) {
      this.props.addInvoiceSubject(subject);
      return;
    }

    this.props.updateInvoiceSubject(subject, subjectId);
  }

  onDeleteSubject(subjectId) {
    this.props.removeInvoiceSubject(subjectId, data => {
      if (Array.isArray(data.invoiceSubjects)) {
        this.setState((prev, props) => {
          return { ...prev, invoiceSubjects: data.invoiceSubjects };
        });
      }
    });
  }

  get exactIsAuthenticated() {
    return this.state.exactAuthStatus;
  }

  get exportBtnDisabled() {
    return !!this.invoice.exportedAt;
  }

  get exportedAtMsg() {
    // Show old message if an invoice has been exported with an old flow
    if (this.props.invoice.exportedAt && !this.invoice.finalizationStatus) {
      return (
        <p>
          {this.lbl('invoice.details.exportedStatus')} {this.invoice.exportedAt}
        </p>
      );
    }
    return <InvoiceFinalizationStatusBar invoice={this.invoice} />;
  }

  get notReadyToExportMsg() {
    return !this.exactIsAuthenticated ? <FieldError errors={[this.lbl('invoice.details.notReadyToExportMsg')]} /> : '';
  }

  get isBlockFinalizeBtn() {
    let isBlock = false;

    if (
      !this.vehicle?.incoming_invoice_finalized &&
      !this.vehicle?.incoming_invoice_in_helga &&
      this.vehicle?.outgoing_invoice_generated &&
      this.invoice?.subjectType !== INVOICE_SUBJECT_TYPES.BPM &&
      env.clientId === AppClientId.AUTOHUISSALLAND
    ) {
      isBlock = true;
    }
    return isBlock;
  }

  exportInvoiceToExact() {
    if (this.needToShowBpmWarning()) {
      this.setState({ bpmWarningModal: true });
      return;
    }

    this.props.exportInvoiceToExact();
  }

  finalizeV2() {
    if (this.requireFields.length) {
      return this.setState({ requireField: this.requireFields, showPrompt: true });
    }

    this.setState({ requireField: [], showPrompt: false });

    const emailIsOptional = !![AUTOHUISSALLAND_INSTALATION.APP_CLIENT_ID].includes(this.props.serverConfig.appClientId);
    if (
      !this.invoice.emailTo &&
      !this.invoice.emailContactId &&
      !this.invoice.financialContactId &&
      this.invoice.direction === INVOICE_DIRECTIONS.OUTGOING &&
      this.invoice?.subjectType !== 'BPM' &&
      !emailIsOptional
    ) {
      this.setState({ showEmailModal: true });
      return;
    }

    if (this.needToUpdateOutgoingBPM) {
      this.setState({ bpmUpdateModal: true });
      return;
    }

    this.props.finalizeV2();
  }

  onEmailModalComplete(dto) {
    this.setState({ showEmailModal: false }, () => {
      this.props.updateInvoiceEmailData(dto, response => {
        if (response.validationErrors) {
          let errorMsg = 'general';
          if (response.validationErrors) {
            errorMsg = Object.values(response.validationErrors[0]?.constraints ?? {})[0] ?? '';
          }
          this.props.addApiError(errorMsg);
        } else {
          if (this.needToUpdateOutgoingBPM) {
            this.setState({ bpmUpdateModal: true });
            return;
          } else {
            this.props.finalizeV2();
          }
        }
      });
    });
  }

  resetCreditInvoiceEmailModal() {
    this.setState({ showCreditInvoiceEmailModal: false, sendToTargetEmail: null, manualEmail: '' });
  }

  renderCreditInvoiceEmailModal() {
    const skipEmail = () => {
      let dto = this.dto;
      dto.skipEmail = true;
      this.props.update(dto, result => {
        if (result?.id) {
          this.props.finalizeV2();
          this.resetCreditInvoiceEmailModal();
        }
      });
    };

    if (this.props.workComment)
      return (
        <Modal>
          <HBox center vCenter>
            <Loader />
          </HBox>
        </Modal>
      );

    return (
      <CreditInvoiceEmailModal
        invoice={this.invoice}
        sendToTargetEmail={this.state.sendToTargetEmail}
        manualEmail={this.state.manualEmail}
        updateInvoiceEmailData={this.props.updateInvoiceEmailData}
        skipEmail={skipEmail}
        addApiError={this.props.addApiError}
        finalizeV2={this.props.finalizeV2}
        setSendToTargetEmail={value => this.setState({ sendToTargetEmail: value })}
        setManualEmail={value => this.setState({ manualEmail: value })}
        manualEmailValue={this.state.manualEmail}
        lbl={this.lbl.bind(this)}
        resetCreditInvoiceEmailModal={this.resetCreditInvoiceEmailModal.bind(this)}
      />
    );
  }

  get needToUpdateOutgoingBPM() {
    const companyFromEu = getPropByName(this.invoice?.outgoingCompany, 'company_from_eu');
    const companyFromEuNorm = companyFromEu?.toUpperCase?.(); // 'EU', 'OUTSIDE_EU', 'NL', etc.
    console.log(companyFromEuNorm, 'companyFromEuNorm');
    if (companyFromEuNorm === 'OUTSIDE_EU') return false;

    if (this.props.serverConfig?.disableBPM) return false;
    if (this.invoice?.type !== 'invoice') return false;

    return (
      this.invoice?.direction === 'outgoing' &&
      ((this.invoice?.subjectType === 'vehicle' && !this.invoice.ledgersEntry.needBPMInvoice) ||
        this.invoice?.subjectType === 'BPM') &&
      !this.invoice?.vehicle?.new_from_factory &&
      this.invoice?.vehicle?.vehiclePurpose !== 'commercial' &&
      this.invoice?.vehicle?.financialAmounts?.rest_bpm != 0
    );
  }

  renderCompany() {
    switch (this.getFieldValue('direction')) {
      case INVOICE_DIRECTIONS.OUTGOING:
        return (
          <HBox vCenter className="field-wrap">
            <strong style={{ flex: '30%' }}>{this.lbl('invoice.create.outgoingCompany')}</strong>
            <HBox style={{ width: '70%' }}>
              <FormField style={{ width: '100%' }}>{this.renderOutgoingCompany()}</FormField>
            </HBox>
          </HBox>
        );
      default:
        return <VBox></VBox>;
    }
  }

  hasVatWarning() {
    if (this.invoice.subjectType === 'BPM' || env.clientId === AppClientId.HOOIKAMMER){
      return false;
    }

    const vatDescription = this.getVatCodeLabel(
      this.vehicleSubject?.subjectVat?.code
    )[0]?.description?.toLowerCase();

    const taxType = this.vehicle?.btwOrMarge?.toLowerCase();

console.log('vatDescription:', vatDescription);
console.log('taxType:', taxType);

    // Case A: VAT-code bevat BTW maar btwOrMarge is NIET 'btw'
    const caseA = vatDescription?.includes('btw') && taxType !== 'btw';

    // Case B: btwOrMarge is 'btw' maar VAT-code bevat GEEN 'BTW'
    const caseB = taxType === 'btw' && !vatDescription?.includes('btw');

    return caseA || caseB;
  }

  renderExportSection() {
    return (
      <VBox>
        {this.state.showPrompt && <RequireMark>{this.lbl('invoice.details.outgoingFinalizeRequiredFieldsMsg')}</RequireMark>}
       
       
       
       
     
  <FormField>{this.renderFinalizeBtn()}</FormField>


{this.hasVatWarning() && env.clientId != AppClientId.AUTOWIENTJES && (
  <div style={{ color: 'red', marginTop: '8px' }}>
    ⚠️ Let op: inconsistentie tussen BTW-code en voertuigtype!
  </div>
)}

        {this.hasVatWarning() && (
          <div style={{ color: 'red', marginTop: '8px' }}>
            ⚠️ Let op: inconsistentie tussen BTW-code en voertuigtype!
          </div>
        )}

        <div style={{ width: '100%' }}>{this.exportedAtMsg}</div>
      </VBox>
    );
  }

  renderFinalizeBtn() {
    const blockFinalizationMessage = this.lbl('invoice.details.block_finalize_message');

    // Show old button if invoice has been finalized with an old flow
    if (this.invoice.isFinal && !this.invoice.finalizationStatus)
      return (
        <Button disabled={this.exportBtnDisabled} onClick={this.exportInvoiceToExact.bind(this)}>
          {this.lbl('invoice.details.exportBtn')}
        </Button>
      );
    const status = getFinalizationStatus(this.props.invoice);
    if (FINALIZATION_STATUSES.READY_TO_INITIATE === status)
      return <Button onClick={this.finalizeV2.bind(this)}>{this.lbl('invoice.details.finalizeV2Btn')}</Button>;

    if (FINALIZATION_STATUSES.DONE === status)
      return (
        <Button disabled={true} onClick={this.finalizeV2.bind(this)}>
          {this.lbl('invoice.details.finalizeV2Btn')}
        </Button>
      );

    if (FINALIZATION_STATUSES.IN_PROGRESS === status)
      return (
        <Button disabled={true} onClick={this.finalizeV2.bind(this)}>
          {this.lbl('invoice.details.finalizeV2Btn')}
        </Button>
      );

    if (FINALIZATION_STATUSES.ERROR === status)
      return (
        <VBox>
          {this.isBlockFinalizeBtn && <strong>{blockFinalizationMessage}</strong>}
          <Button disabled={this.isBlockFinalizeBtn} onClick={this.props.retryFinalizationV2.bind(this)}>
            {this.lbl('invoice.details.retryFinalizeV2Btn')}
          </Button>
        </VBox>
      );

    return '';
  }

  showCreditModal() {
    this.setState({ showCreditModal: true });
  }

  showCreditAndCopyModal = () => {
    this.setState({ showCreditModal: true, copyAfterCredit: true });
  };

  get showCreditButton() {
    if (this.invoice?.creditInvoiceId) {
      return false;
    }
    return (
      !!this.invoice.exportedAt &&
      this.invoice.type !== INVOICE_TYPES.CREDIT &&
      (!this.invoice.finalizationStatus || this.invoice.finalizationStatus === 'DONE')
    );
  }

  renderCreditModal() {
    return (
      this.state.showCreditModal && (
        <CreditInvoiceModal
          onConfirm={this.onConfirmCreditModal.bind(this)}
          onCancel={this.onCancelCreditModal.bind(this)}
        />
      )
    );
  }

  onConfirmCreditModal() {
    let showQuizCredit = false;
    if (env.wientjes_installation || env.autohuis_salland_installation) {
      if (this.invoice.subjectType === INVOICE_SUBJECT_TYPES.VEHICLE) showQuizCredit = false;
    } else {
      if (this.invoice.subjectType === INVOICE_SUBJECT_TYPES.VEHICLE) showQuizCredit = true;
    }

    if (!showQuizCredit) {
      this.setState({ showCreditModal: false }, this.sendCreditRequest([]));
    } else {
      this.setState({ showQuizCredit, showCreditModal: false });
    }
  }

  sendCreditRequest = properties => {
    this.setState(
      { showQuizCredit: false },

      this.props.createCreditInvoice(properties, result => {
        if (typeof result === 'number' && this.state.copyAfterCredit) {
          this.setState({ showCopyInvoiceModal: true });
          return;
        }
        if (typeof result === 'number') {
          this.to(`/invoices/outgoing/${result}`);
        }
      }),
    );
  };

  onCancelQuiz = () => {
    this.setState({ showQuizCredit: false, showQuizDelete: false, copyAfterCredit: false });
  };

  onCancelCreditModal() {
    this.setState({ showCreditModal: false, copyAfterCredit: false });
  }

  renderCreditSection() {
    if (this.showCreditButton)
      return (
        <VBox gap={'8px'}>
          <FormField>
            <Button warning={true} onClick={this.showCreditModal.bind(this)}>
              {this.lbl('invoice.details.creditBtn')}
            </Button>
          </FormField>
          <FormField>
            <Button warning={true} onClick={this.showCreditAndCopyModal.bind(this)}>
              {this.lbl('invoice.details.creditAndCopyBtn')}
            </Button>
          </FormField>

          {this.renderCreditModal()}
        </VBox>
      );

    return '';
  }

  showDeclineModal() {
    this.setState({ showDeclineModal: true });
  }

  renderDeclineSection() {
    return;
    if (this.showDeclineButton)
      return (
        <VBox>
          <FormField>
            <Button warning={true} onClick={this.showDeclineModal.bind(this)}>
              {this.lbl('invoice.details.declineBtn')}
            </Button>
          </FormField>
          {this.renderDeclineModal()}
        </VBox>
      );

    return '';
  }

  onConfirmDeclineModal() {
    this.setState({ showDeclineModal: false }, this.props.declineInvoice);
  }

  onCancelDeclineModal() {
    this.setState({ showDeclineModal: false });
  }

  renderDeclineModal() {
    return (
      this.state.showDeclineModal && (
        <DeclineInvoiceModal
          onConfirm={this.onConfirmDeclineModal.bind(this)}
          onCancel={this.onCancelDeclineModal.bind(this)}
        />
      )
    );
  }

  get showDeclineButton() {
    return !!this.invoice.isFinal;
  }

  renderDeleteSection() {
    if (this.showDeleteButton)
      return (
        <VBox style={{ paddingTop: '10px' }}>
          <FormField>
            <Button warning={true} onClick={this.showDeleteModal}>
              {this.lbl('invoice.details.deleteBtn')}
            </Button>
          </FormField>
          {this.renderDeleteModal()}
        </VBox>
      );

    return '';
  }

  get showDeleteButton() {
    return !this.invoice.isFinal;
  }

  showDeleteModal = () => {
    this.setState({ showDeleteModal: true });
  };

  onConfirmDeleteModal() {
    let showQuizDelete = false;

    if (env.wientjes_installation || env.autohuis_salland_installation) {
      if (this.invoice.subjectType === INVOICE_SUBJECT_TYPES.VEHICLE) showQuizDelete = false;
    } else {
      if (this.invoice.subjectType === INVOICE_SUBJECT_TYPES.VEHICLE) showQuizDelete = true;
    }

    if (!showQuizDelete) {
      this.setState({ showDeleteModal: false }, this.sendDeleteRequest([]));
    } else {
      this.setState({ showDeleteModal: false, showQuizDelete });
    }
  }

  onCancelDeleteModal() {
    this.setState({ showDeleteModal: false });
  }

  sendDeleteRequest = properties => {
    const vehicleId = this.invoice?.vehicle?.id;
    this.setState({ showQuizDelete: false }, this.props.deleteInvoice(properties, this.redirectAfterDelete, vehicleId));
  };

  renderDeleteModal() {
    return (
      this.state.showDeleteModal && (
        <DeleteInvoiceModal
          onConfirm={this.onConfirmDeleteModal.bind(this)}
          onCancel={this.onCancelDeleteModal.bind(this)}
        />
      )
    );
  }

  redirectAfterDelete = () => {
    if (this.invoice?.vehicle?.id) {
      return this.to(`/vehicles/${this.invoice?.vehicle?.id}`);
    } else {
      return this.to(`/invoices`);
    }
  };

  get vehicleSubject() {
    const subjects = this.invoice.invoiceSubjects ?? [];
    if (!subjects.length) return null;
    return subjects.find(s => INVOICE_SUBJECT_TYPES.VEHICLE === s.type);
  }

  get showSyncBPMBtn() {
    const vehicleSubject = this.vehicleSubject;
    if (!vehicleSubject) return false;
    const vehicle = vehicleSubject.vehicle;
    if (!vehicle) return false;
    return (
      !(vehicle?.financialAmounts?.rest_bpm === vehicleSubject.rest_bpm) ||
      !(vehicle?.financialAmounts?.financial_bpm_gross === vehicleSubject.financial_bpm_gross)
    );
  }

  onSyncBpm() {
    this.props.syncBpm();
  }

  get syncBpmDisabled() {
    return this.invoice.isFinal;
  }

  renderSyncBpmSection() {
    return (
      <VBox>
        <FormField>
          <Button warning={true} onClick={this.onSyncBpm.bind(this)}>
            {this.lbl('invoice.details.syncBpmBtn')}
          </Button>
        </FormField>
      </VBox>
    );
  }

  needToShowBpmWarning() {
    const vehicleSubject = this.vehicleSubject;
    if (!vehicleSubject) return false;
    const vehicle = vehicleSubject?.vehicle;
    if (!vehicle) return false;
    if (vehicle.vehiclePurpose === 'commercial') return false;
    return !vehicleSubject.rest_bpm || !vehicleSubject.financial_bpm_gross;
  }

  onCancelBpmWarning() {
    this.setState({ bpmWarningModal: false });
  }

  onChangeComment(evt) {
    this.setState({ extraComment: evt.target.value, disableEditCommentButton: false });
  }

  bpmWarningOnConfirm() {
    this.setState({ bpmWarningModal: false });
    this.props.exportInvoiceToExact();
  }

  renderBpmWarningModal() {
    return (
      this.state.bpmWarningModal && (
        <BpmWarningModal onConfirm={this.bpmWarningOnConfirm.bind(this)} onCancel={this.onCancelBpmWarning.bind(this)} />
      )
    );
  }

  getVehicleId = () => this.state.selectedVehicle?.id ?? this.props.invoice?.vehicleId ?? this.props.invoice?.vehicle?.id;

  cancelBpmUpdate = () => {
    this.setState({ showConfirmBpmModal: false, isFinal: false });
  };

  confirmBpmUpdate = () => {
    this.setState({ showConfirmBpmModal: false, isFinal: true });
  };
  renderConfirmBpmModal = () => {
    return (
      <Modal title={this.lbl('invoice.details.warning')}>
        {this.lbl('invoice.details.diffWarning')}
        <ModalControls>
          <Button onClick={this.cancelBpmUpdate}>{this.lbl('invoice.filter.no')}</Button>
          <Button onClick={this.confirmBpmUpdate}>{this.lbl('invoice.filter.yes')}</Button>
        </ModalControls>
      </Modal>
    );
  };

  renderUpdateDateBtn() {
    const originDate = this.props?.invoice?.date ? dayjs(this.props?.invoice?.date).format('YYYY-MM-DD') : null;
    const currentDate = this.getFieldValue('date') ? dayjs(this.getFieldValue('date')).format('YYYY-MM-DD') : null;
    console.log('currentDate', currentDate);
    console.log('originDate', originDate);
    const dateChanged = currentDate && originDate !== currentDate;
    return (
      dateChanged && (
        <Button
          small
          onClick={() => {
            this.props.updateInvoiceDate(this.getFieldValue('date'));
          }}
        >
          <Check />
        </Button>
      )
    );
  }

  onConfirmBPMModal(value) {
    this.setState({ bpmUpdateModal: false });
    this.props.updateInvoiceOutgoingBpm(value, data => {
      if (data.success) this.props.finalizeV2();
    });
  }
  renderOutgoingBPMModal() {
    if (!this.state.bpmUpdateModal) return '';
    return (
      <OutgoingBPMModal
        invoice={this.invoice}
        onConfirm={this.onConfirmBPMModal.bind(this)}
        onCancel={() => this.setState({ bpmUpdateModal: false })}
      />
    );
  }

  render() {
    if (
      this.props.work ||
      this.props.workExport ||
      this.props.workDecline ||
      this.props.workSyncBPM ||
      this.props.workCredit ||
      this.props.workUpdateBPM ||
      !this.props.invoice
    )
      return (
        <>
          <PageHeader
            title={
              <div className="pointer" onClick={this.tofn(`/invoices`)}>
                <Left />
                {this.lbl('invoices')}
              </div>
            }
          />
          <LoadingDetailsPage />
        </>
      );

    if (this.props.workDelete) {
      return <LoadingWithNotification message={this.lbl('invoice.details.delete_order_notification')} />;
    }

    return (
      <Container limit={this.extraCommentTextLimit}>
        <PageHeader
          title={
            <div className="pointer" onClick={this.tofn(`/invoices`)}>
              <Left />
              {this.lbl('invoices')}
            </div>
          }
        />
        {this.renderOutgoingCompanyEdit()}
        {this.renderDirectionEdit()}
        {this.renderTypeEdit()}
        {this.renderStatusEdit()}
        {this.renderBpmWarningModal()}
        {this.renderOutgoingBPMModal()}
        {!!this.state.showConfirmBpmModal && this.renderConfirmBpmModal()}
        {!!this.state.showQuizCredit && (
          <InvoiceQuizModal
            direction={this.invoice.direction}
            vehicle={this.vehicleSubject?.vehicle}
            onConfirm={this.sendCreditRequest}
            onCancel={this.onCancelQuiz}
          />
        )}
        {!!this.state.showQuizDelete && (
          <InvoiceQuizModal
            direction={this.invoice.direction}
            vehicle={this.vehicleSubject?.vehicle}
            onConfirm={this.sendDeleteRequest}
            onCancel={this.onCancelQuiz}
          />
        )}
        {this.state.showCreditInvoiceEmailModal && this.renderCreditInvoiceEmailModal()}

        <Content>
          <h3 style={{ paddingBottom: '10px', paddingTop: '20px', marginLeft: '10px' }}>
            {this.props?.invoice?.entryNumber && 'Factuurnummer:  ' + this.props?.invoice?.entryNumber}
          </h3>
          <VBox right>
            <HBox className="grid">
              <VBox>
                <HBox vCenter className="field-wrap">
                  <strong style={{ flex: '30%' }}>{this.lbl('invoice.create.date')}</strong>
                  <HBox style={{ flex: '70%' }}>
                    <FormField style={{ width: '100%' }}>
                      <Input
                        style={{ width: '100%' }}
                        disabled
                        value={this.getFieldValue('date') ? dayjs(this.getFieldValue('date')).format('DD-MM-YYYY') : ''}
                      />
                      {this.renderUpdateDateBtn()}
                    </FormField>
                  </HBox>
                </HBox>

                <HBox vCenter className="field-wrap">
                  <strong style={{ flex: '30%' }}>{this.lbl('invoice.create.finalized')}</strong>
                  <HBox style={{ flex: '70%' }}>
                    <FormField style={{ width: '100%' }}>
                      <Checkbox disabled checked={this.getFieldValue('isFinal')}></Checkbox>
                    </FormField>
                  </HBox>
                </HBox>
                <HBox vCenter className="field-wrap">
                  <strong style={{ flex: '30%' }}>{this.lbl('invoice.create.seller')}</strong>
                  <HBox style={{ flex: '70%' }}>
                    <WithUser user_id={this.props.invoice?.vehicle?.user_seller_id} inputLabel></WithUser>
                  </HBox>
                </HBox>
                <HBox vCenter className="field-wrap">
                  <strong style={{ flex: '30%' }}>{this.lbl('invoice.create.direction')}</strong>
                  <HBox style={{ width: '70%' }}>{this.renderDirection()}</HBox>
                </HBox>

                <HBox vCenter className="field-wrap">
                  <strong onClick={this.onEditStatus.bind(this)} style={{ flex: '30%' }}>
                    {this.lbl('invoice.create.status')}
                  </strong>
                  <HBox vCenter style={{ width: '70%' }}>
                    {' '}
                    {this.renderStatus()}
                    <PaymentsLog invoice={this.invoice} smallBtn />
                  </HBox>
                </HBox>
                <HBox style={{ width: '50%', maxWidth: '225px', marginLeft: '12px', color: '#0183D5' }}>
                  <strong
                    onClick={this.tofn(`/vehicles/${this.vehicle?.id}`)}
                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                  >
                    {this.lbl('invoice.details.open_vehicle')}
                  </strong>
                </HBox>
                {this.renderBpmInvoiceAdditionalVehicleInfo()}
              </VBox>
              <VBox>
                {this.renderCompany()}
                <HBox vCenter className="field-wrap">
                  <strong style={{ flex: '30%' }}>{this.lbl('invoice.create.addressline1')}</strong>
                  <HBox style={{ width: '70%' }}>
                    <FormField style={{ width: '100%' }}>
                      <Input style={{ width: '100%' }} disabled value={this.outgoingCompanyHome[0]?.addressLine1 ?? ''} />
                    </FormField>
                  </HBox>
                </HBox>
                <HBox vCenter className="field-wrap">
                  <strong style={{ flex: '30%' }}>{this.lbl('company.details.postcode')}</strong>
                  <HBox style={{ width: '70%' }}>
                    <FormField style={{ width: '100%' }}>
                      <Input style={{ width: '100%' }} disabled value={this.outgoingCompanyHome[0]?.postcode ?? ''} />
                    </FormField>
                  </HBox>
                </HBox>
                <HBox vCenter className="field-wrap">
                  <strong style={{ flex: '30%' }}>{this.lbl('company.details.city')}</strong>
                  <HBox style={{ width: '70%' }}>
                    <FormField style={{ width: '100%' }}>
                      <Input style={{ width: '100%' }} disabled value={this.outgoingCompanyHome[0]?.city ?? ''} />
                    </FormField>
                  </HBox>
                </HBox>
                <HBox vCenter className="field-wrap">
                  <strong style={{ flex: '30%' }}>{this.lbl('company.details.country')}</strong>
                  <HBox style={{ width: '70%' }}>
                    <FormField style={{ width: '100%' }}>
                      <Input
                        style={{ width: '100%' }}
                        disabled
                        value={translateCountry(this.outgoingCompanyHome[0]?.country.name, this.locale) ?? ''}
                      />
                    </FormField>
                  </HBox>
                </HBox>
                <HBox style={{ width: '50%', maxWidth: '225px', marginLeft: '12px', color: '#0183D5' }}>
                  <strong
                    onClick={this.tofn(`/companies/${this.invoice?.outgoingCompany.id}`)}
                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                  >
                    {this.lbl('invoice.details.open_debitor')}
                  </strong>
                </HBox>
                {this.isRequired(getPropByName(this.invoice?.outgoingCompany, 'BTW_number')) && (
                  <>
                    <HBox vCenter className="field-wrap">
                      <strong style={{ flex: '30%' }}>
                        {this.lbl('company.details.btw_number')}{' '}
                        {this.isRequired(getPropByName(this.invoice?.outgoingCompany, 'BTW_number'))}
                      </strong>

                      <HBox style={{ width: '70%' }}>
                        <FormField style={{ width: '100%' }}>{this.btwDropdown()}</FormField>
                      </HBox>
                    </HBox>
                    <HBox vCenter className="field-wrap">
                      <HBox style={{ width: '70%' }}>
                        <Button
                          disabled={!this.state.companyValues?.BTW_number}
                          onClick={() => this.onSetCompanyProperty('BTW_number', this.state.companyValues?.BTW_number)}
                        >
                          {this.lbl('invoice.details.update_company_btw_number')}
                        </Button>
                      </HBox>
                    </HBox>
                  </>
                )}
              </VBox>
              <VBox>
                <HBox vCenter className="field-wrap">
                  <strong style={{ flex: '30%' }}>
                    {this.lbl('vehicle.filter.regplate')}
                    {this.isRequired(this.vehicle?.regplate)}
                  </strong>

                  <HBox style={{ width: '70%' }}>
                    {this.isRequired(this.vehicle?.regplate) && (
                      <FormField style={{ width: '100%' }}>
                        <Input
                          name={'regplate'}
                          style={{ width: '100%' }}
                          disabled={this.isRequired(this.vehicle?.regplate) ? false : true}
                          onChange={evt => this.onVehicleValueChange(evt)}
                          value={this.state.vehicleValues?.regplate ?? ''}
                        />
                      </FormField>
                    )}
                    {!this.isRequired(this.vehicle?.regplate) && <RegplateLabel regplate={this.vehicle?.regplate} />}
                  </HBox>
                </HBox>
                <HBox vCenter className="field-wrap">
                  <strong style={{ flex: '30%' }}>
                    {this.lbl('vehicle.filter.vin')} {this.isRequired(this.vehicle?.vin)}
                  </strong>
                  <HBox style={{ width: '70%' }}>
                    <FormField style={{ width: '100%' }}>
                      <Input
                        name={'vin'}
                        style={{ width: '100%' }}
                        disabled={this.isRequired(this.vehicle?.vin) ? false : true}
                        onChange={evt => this.onVehicleValueChange(evt)}
                        value={this.state.vehicleValues?.vin ?? ''}
                      />
                    </FormField>
                  </HBox>
                </HBox>
                <HBox vCenter className="field-wrap">
                  <strong style={{ flex: '30%' }}>
                    {this.lbl('vehicle.filter.brandName')} {this.isRequired(this.vehicle?.brandName)}
                  </strong>
                  {this.isRequired(this.vehicle?.brandName) ? (
                    <HBox style={{ width: '70%' }}>
                      <FormField style={{ width: '100%' }}>
                        <VehicleCreateFieldBrandName
                          key={this.props.type}
                          type={'brand_name'}
                          editInvoice
                          deletable
                          invoiceVehicleValue={this.state.vehicleValues?.brandName}
                          onChange={value => this.onVehicleValueChange(null, 'brandName', value)}
                          onDeleteValue={() =>
                            this.setState(prev => ({
                              vehicleValues: { ...prev.vehicleValues, brandName: '' },
                            }))
                          }
                          onManual={value => {}}
                        />
                      </FormField>
                    </HBox>
                  ) : (
                    <HBox style={{ width: '70%' }}>
                      <FormField style={{ width: '100%' }}>
                        <Input
                          name={'brandName'}
                          style={{ width: '100%' }}
                          disabled
                          onChange={evt => this.onVehicleValueChange(evt)}
                          value={this.state.vehicleValues?.brandName ?? ''}
                        />
                      </FormField>
                    </HBox>
                  )}
                </HBox>
                <HBox vCenter className="field-wrap">
                  <strong style={{ flex: '30%' }}>
                    {this.lbl('vehicle.filter.modelName')} {this.isRequired(this.vehicle?.modelName)}
                  </strong>
                  {this.isRequired(this.vehicle?.modelName) || this.isRequired(this.vehicle?.brandName) ? (
                    <HBox style={{ width: '70%' }}>
                      <FormField style={{ width: '100%' }}>
                        <VehicleCreateFieldModelName
                          key={this.props.type}
                          type={'model_name'}
                          editInvoice
                          deletable
                          invoiceVehicleValue={this.state.vehicleValues?.modelName}
                          invoiceVehicleBrand={this.state.vehicleValues?.brandName}
                          onChange={value => this.onVehicleValueChange(null, 'modelName', value)}
                          onDeleteValue={() =>
                            this.setState(prev => ({
                              vehicleValues: { ...prev.vehicleValues, modelName: '' },
                            }))
                          }
                          onManual={value => {}}
                        />
                      </FormField>
                    </HBox>
                  ) : (
                    <HBox style={{ width: '70%' }}>
                      <FormField style={{ width: '100%' }}>
                        <Input
                          name={'modelName'}
                          style={{ width: '100%' }}
                          disabled
                          onChange={evt => this.onVehicleValueChange(evt)}
                          value={this.state.vehicleValues?.modelName ?? ''}
                        />
                      </FormField>
                    </HBox>
                  )}
                </HBox>
                <HBox vCenter className="field-wrap">
                  <strong style={{ flex: '30%' }}>
                    {this.lbl('vehicle.filter.date_first_allowance')}
                    {this.isRequired(this.vehicle?.date_first_allowance)}
                  </strong>
                  {this.isRequired(this.vehicle.date_first_allowance) ? (
                    <HBox style={{ width: '70%' }}>{this.datePicker('date_first_allowance')}</HBox>
                  ) : (
                    <HBox style={{ width: '70%' }}>
                      <FormField style={{ width: '100%' }}>
                        <Input
                          name={'date_first_allowance'}
                          style={{ width: '100%' }}
                          disabled={this.isRequired(this.vehicle?.date_first_allowance) ? false : true}
                          value={
                            this.vehicle?.date_first_allowance ? getDate(this.state.vehicleValues?.date_first_allowance) : ''
                          }
                        />
                        {this.renderUpdateDateBtn()}
                      </FormField>
                    </HBox>
                  )}
                </HBox>
                <HBox vCenter className="field-wrap">
                  <strong style={{ flex: '30%' }}>
                    {this.lbl('vehicle.filter.mileage')} {this.isRequired(this.vehicle?.mileage)}
                  </strong>
                  <HBox style={{ width: '70%' }}>
                    <FormField style={{ width: '100%' }}>
                      <Input
                        style={{ width: '100%' }}
                        disabled={this.isRequired(this.vehicle?.mileage) ? false : true}
                        name={'mileage'}
                        onChange={evt => this.onVehicleValueChange(evt)}
                        value={this.state.vehicleValues?.mileage ?? ''}
                        rightDecoration={<DecoratorLabel>KM</DecoratorLabel>}
                      />
                    </FormField>
                  </HBox>
                </HBox>
                <HBox vCenter className="field-wrap">
                  <strong style={{ flex: '30%' }}>{this.lbl('vehicle.filter.imported')}</strong>
                  <HBox style={{ width: '70%' }}>
                    <FormField style={{ width: '100%' }}>
                      <Checkbox disabled checked={this.vehicle?.import}></Checkbox>
                    </FormField>
                  </HBox>
                </HBox>
                <HBox vCenter className="field-wrap">
                  <strong style={{ flex: '30%' }}>{this.lbl('vehicle.filter.new_from_factory')}</strong>
                  <HBox style={{ width: '70%' }}>
                    <FormField style={{ width: '100%' }}>
                      <Input
                        style={{ width: '100%' }}
                        disabled
                        value={this.vehicle?.new_from_factory ? 'Nieuw' : 'Gebruikt'}
                      />
                    </FormField>
                  </HBox>
                </HBox>
                <HBox vCenter className="field-wrap">
                  <strong style={{ flex: '30%' }}>{this.lbl('product.create.col.buyier')}</strong>
                  <HBox style={{ width: '70%' }}>
                    <FormField style={{ width: '100%' }}>
                      <VehicleCreateFieldCompanyUser
                        style={{ width: '100%' }}
                        selectedCreditorId={this.vehicle?.buying_contact}
                        companyId={this.vehicle?.buyingCompany?.id}
                        disabled
                        formField
                      />
                    </FormField>
                  </HBox>
                </HBox>
                <HBox vCenter className="field-wrap">
                  <strong style={{ flex: '30%' }}>{this.lbl('vehicle.property.buying_company')}</strong>
                  <HBox style={{ width: '70%' }}>
                    <FormField style={{ width: '100%' }}>
                      <VehicleCreateFieldCompany
                        style={{ width: '100%' }}
                        selectedCompanyId={this.vehicle?.buyingCompany?.id}
                        disabled
                        formField
                      />
                    </FormField>
                  </HBox>
                </HBox>
                <HBox vCenter className="field-wrap">
                  <strong style={{ flex: '30%' }}>
                    {this.lbl('vehicle.property.btwOrMarge')}
                    {this.isRequired(this.vehicle?.btwOrMarge)}
                  </strong>
                  {this.isRequired(this.vehicle?.btwOrMarge) ? (
                    <HBox style={{ width: '70%' }}>
                      <FormField style={{ width: '100%' }}>{this.dropdown('btwOrMarge')}</FormField>
                    </HBox>
                  ) : (
                    <HBox style={{ width: '70%' }}>
                      <FormField style={{ width: '100%' }}>
                        <Input
                          name={'btwOrMarge'}
                          style={{ width: '100%' }}
                          disabled={this.isRequired(this.vehicle?.btwOrMarge) ? false : true}
                          type="currency"
                          onChange={evt => this.onVehicleValueChange(evt)}
                          value={this.state.vehicleValues?.btwOrMarge}
                        />
                      </FormField>
                    </HBox>
                  )}
                </HBox>
                <HBox vCenter className="field-wrap">
                  <strong style={{ flex: '30%' }}>{this.lbl('vehicle.property.rest_bpm')}</strong>
                  <HBox style={{ width: '70%' }}>
                    <FormField style={{ width: '100%' }}>
                      <Input
                        style={{ width: '100%' }}
                        disabled
                        type="currency"
                        value={this.vehicle?.financialAmounts?.rest_bpm}
                      />
                    </FormField>
                  </HBox>
                </HBox>
                {this.state.showPrompt && (
                  <HBox vCenter className="field-wrap">
                    <HBox style={{ width: '70%' }}>
                      <Button onClick={this.onUpdateVehicle.bind(this)}>
                        {this.lbl('invoice.details.update_vehicle_properties')}
                      </Button>
                    </HBox>
                  </HBox>
                )}
              </VBox>
            </HBox>

            <HBox></HBox>
            <HBox></HBox>

            <HBox>
              {this.props.invoice.subjectType !== INVOICE_SUBJECT_TYPES.PRODUCT && (
                <HBox vCenter left style={{ paddingTop: '30px', width: '90%' }}>
                  <VBox style={{ width: '100%' }}>
                    <strong style={{ marginLeft: '10px', marginTop: '60px', fontSize: '22px' }}>
                      {this.lbl('invoice.subject.title')}
                    </strong>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <p style={{ width: '250px', fontWeight: 'bold', paddingLeft: '10px', fontSize: '12px' }}>
                        {this.lbl('invoice.invoiceAddittionalLines.extraComment')}:
                      </p>
                      <VBox>
                        <FormField>
                          <Input
                            type="textarea"
                            style={{ width: '100%', marginTop: '5px' }}
                            disabled={this.getFieldValue('isFinal')}
                            name="extra_comment"
                            value={(this.state.extraComment || this.props.invoice.invoiceAdditionalLines[0]?.value) ?? ''}
                            onChange={this.onChangeComment.bind(this)}
                            rightDecoration={
                              <Button
                                disabled={
                                  this.state.disableEditCommentButton ||
                                  this.props.workComment ||
                                  this.extraCommentTextLimit < 0
                                }
                                small
                                onClick={this.onUpdate.bind(this)}
                              >
                                {this.props.workComment ? <Loader small /> : <Check />}
                              </Button>
                            }
                          />
                        </FormField>
                        <HBox vCenter gap={'8px'} left className={'textLimit'}>
                          {this.lbl('invoice.details.text_limit')}:<span>{this.extraCommentTextLimit}</span>
                        </HBox>
                      </VBox>
                    </div>

                    <FormField>


                      <InvoiceSubjectContainer
                        outgoingDesignV2
                        items={this.getFieldValue('invoiceSubjects')}
                        onSaveSubject={this.onSaveSubject.bind(this)}
                        onDeleteSubject={this.onDeleteSubject.bind(this)}
                        direction={this.getFieldValue('direction')}
                        totalAmount={this.getFieldValue('financialTotalAmount')}
                        incomingCompanyId={this.getFieldValue('incomingCompanyId')}
                        outgoingCompanyId={this.getFieldValue('outgoingCompanyId')}
                        isBrutoScenario={this.getFieldValue('isBrutoScenario')}
                        vehiclePurpose={this.props.invoice.vehicle.vehiclePurpose}
                        vehicleId={this.getFieldValue('vehicleId')}
                      />
                    </FormField>
                  </VBox>
                  <VBox vCenter style={{ marginBottom: '24px', marginLeft: '40px', width: '100%', marginTop: '-280px' }}>
                    <strong style={{ marginLeft: '10px', marginBottom: '15px', fontSize: '24px' }}>
                      {this.lbl('invoice.subject.exact')}
                    </strong>
                    {this.renderExportSection()}
                    <VBox vCenter style={{ paddingTop: '10px' }}>
                      {this.renderDeclineSection()}
                    </VBox>

                    <VBox vCenter style={{ paddingTop: '10px' }}>
                      {this.renderCreditSection()}
                    </VBox>
                    {this.state.showCopyInvoiceModal && (
                      <ModalComponent onClose={this.setStateFn({ showCopyInvoiceModal: false })}>
                        <VehicleAddToOrderCard
                          vehicleId={this.props.invoice?.vehicle?.id}
                          invoice={this.props.invoice}
                          copyFromInvoiceId={this.props.invoice?.id}
                        />
                      </ModalComponent>
                    )}
                    <Permission permission={INVOICE_DELETE}>{this.renderDeleteSection()}</Permission>
                    <VBox vCenter style={{ paddingTop: '10px' }}>
                      {this.renderSyncBpmSection()}
                    </VBox>
                  </VBox>
                </HBox>
              )}
            </HBox>
            <HBox style={{ marginBottom: '24px', width: '100%', paddingTop: '20px' }}></HBox>

            <HBox></HBox>

            <HBox></HBox>
          </VBox>
          <LedgersPosting ledgersEntry={this.invoice.ledgersEntry}></LedgersPosting>
        </Content>
        {this.state.showEmailModal && (
          <ProductInvoiceEmailModal
            invoice={this.invoice}
            onComplete={this.onEmailModalComplete.bind(this)}
            onClose={() => this.setState({ showEmailModal: false })}
          />
        )}
      </Container>
    );
  }
}

OutgoingInvoiceDetailsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    invoice: selectInvoice(),
    vehicle: id => selectVehicle(id),
    syncedBpm: selectAutotelexBPM(),
    work: selectWork(REQUEST_INVOICE, REQUEST_EXACT_AUTH_STATUS),
    workComment: selectWork(REQUEST_UPDATE_INVOICE),
    workAuthStatus: selectWork(REQUEST_EXACT_AUTH_STATUS),
    workExport: selectWork(REQUEST_EXACT_EXPORT_INVOICE),
    workDecline: selectWork(REQUEST_INVOICE_DECLINE),
    workDelete: selectWork(REQUEST_INVOICE_DELETE),
    workSyncBPM: selectWork(REQUEST_SYNC_BPM),
    workCredit: selectWork(REQUEST_CREATE_CREDIT_INVOICE),
    workViesCheck: selectWork(REQUEST_VIES_CHECK),
    workUpdateBPM: selectWork(REQUEST_UPDATE_INVOICE_OUTGOING_BPM),
    serverConfig: selectConfig(),
      vatCodes: selectVatCodes(),
    addressTypes: selectAddressTypes(),
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    update(dto, callback) {
      dispatch(updateInvoice(ownProps.invoice_id, dto, callback));
    },
    fetchInvoice(callback) {
      dispatch(fetchInvoice(ownProps.invoice_id, callback));
    },
    removeInvoiceSubject(subjectId, callback) {
      dispatch(removeInvoiceSubject(subjectId, ownProps.invoice_id));
    },
    exportInvoiceToExact() {
      dispatch(exportInvoiceToExact(ownProps.invoice_id));
    },
    finalizeV2() {
      dispatch(finalizeV2(ownProps.invoice_id));
    },
    retryFinalizationV2() {
      dispatch(retryFinalizationV2(ownProps.invoice_id));
    },
    addInvoiceSubject(subject) {
      dispatch(addInvoiceSubject(subject, ownProps.invoice_id));
    },
    updateInvoiceSubject(subject, subjectId, callback) {
      dispatch(updateInvoiceSubject(subject, ownProps.invoice_id, subjectId, callback));
    },
    updateInvoiceStatus(statusId, callback) {
      dispatch(updateInvoiceStatus(ownProps.invoice_id, statusId, callback));
    },
    showError(error) {
      dispatch(addApiError(error));
    },
    declineInvoice() {
      dispatch(declineInvoice(ownProps.invoice_id));
    },
    deleteInvoice(properties, callback, vehicleId) {
      dispatch(deleteInvoice(ownProps.invoice_id, callback, properties, vehicleId));
    },
    syncBpm() {
      dispatch(syncBpm(ownProps.invoice_id));
    },
    createCreditInvoice(properties, callback) {
      dispatch(createCreditInvoice(ownProps.invoice_id, properties, callback));
    },
    getCurrentRestBpm(vehicleId, callback) {
      dispatch(getCurrentRestBpm(vehicleId, callback));
    },
    updateInvoiceDate(date) {
      dispatch(updateInvoiceDate(ownProps.invoice_id, date));
    },
    updateInvoiceOutgoingBpm(value, callback) {
      dispatch(updateInvoiceOutgoingBpm(ownProps.invoice_id, value, callback));
    },
    deleteSubject: subjectId => {
      dispatch(removeInvoiceSubject(subjectId, ownProps.invoice_id));
    },
    updateInvoiceEmailData: (dto, callback) => {
      dispatch(updateInvoiceEmailData(ownProps.invoice_id, dto, callback));
    },
    updateVehicle(vehicleId, props, callback) {
      dispatch(setVehicleProperties(vehicleId, props, callback));
    },
     getCode() {
              dispatch(getVatCodes());
            },
    updateCompanyProperty(companyId, name, value, callback) {
      dispatch(setCompanyProperty(companyId, name, value, callback));
    },
    addApiError(msg) {
      dispatch(addApiError(msg));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const OutgoingInvoiceDetails = compose(withConnect, withRouter, injectIntl)(OutgoingInvoiceDetailsComp);
